const refs = {
    categoryBtn: document.querySelector('.categories__btn'),
    categories: document.querySelector('.categories'),
    products: document.querySelector('.products'),
    loadMoreBtn: document.querySelector('.load-more-btn'),
    searchForm: document.querySelector('.search-form'),
    themeBtn: document.querySelector('.theme-toggle-btn'),
    scrollTopBtn: document.querySelector('.scroll-top-btn'),
    notFound: document.querySelector('.not-found'),
    modal: document.querySelector('.modal'),
    modalRenderProduct: document.querySelector('.modal-product'),
    productsItem: document.querySelector('.products__item'),
    modalCloseBtn: document.querySelector('.modal__close-btn'),
    dataCardCount: document.querySelector('[data-cart-count]'),
    dataWishCount: document.querySelector('[data-wishlist-count]'),
};
// import iziToast from 'izitoast';
// import 'izitoast/dist/css/iziToast.min.css';
export default refs;


